"use client";

/**
 * ContactHero - positioning copy for /contact.
 *
 * Lives in its own client component so the text reacts to live
 * locale toggles. Server-component rendering bakes translations at
 * request time; the language switcher only calls
 * `window.history.replaceState(...)` (no navigation), which means a
 * server-rendered string is stuck on the first-render locale until
 * the user hard-refreshes. Client components subscribe to the
 * LocaleContext and re-render immediately.
 */
import { useT } from "@/lib/locale-context";

export default function ContactHero() {
  const t = useT();
  return (
    <header className="max-w-2xl">
      <div className="text-xs font-semibold text-gray-500">
        {t("contact.hero.eyebrow")}
      </div>
      <h1 className="mt-2 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
        {t("contact.hero.title")}
      </h1>
      <p className="mt-4 text-base sm:text-lg text-gray-600 leading-relaxed">
        {t("contact.hero.body")}
      </p>
    </header>
  );
}
